
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SupportChatHeadOverflow extends Vue {
  @Prop({ type: Number, required: true }) count!: number;

  @Prop({ type: Boolean, default: false }) hasOverflowUnread!: boolean;
}
